import { notify } from 'utils/reduxUtils';

export const types = {
  CREATE_PAYMENT_TERMS_ERROR:
    'common/drawers/accountDrawer/CREATE_PAYMENT_TERMS_ERROR',
  CREATE_PAYMENT_TERMS_REQUEST:
    'common/drawers/accountDrawer/CREATE_PAYMENT_TERMS_REQUEST',
  CREATE_PAYMENT_TERMS_SUCCESS:
    'common/drawers/accountDrawer/CREATE_PAYMENT_TERMS_SUCCESS',
  GET_PAYMENT_TERMS: 'common/drawers/accountDrawer/GET_PAYMENT_TERMS',
  PAYMENT_TERMS_DRAWER_CLOSE:
    ' common/drawers/accountDrawer/PAYMENT_TERMS_DRAWER_CLOSE',
  PAYMENT_TERMS_DRAWER_OPEN:
    'common/drawers/accountDrawer/PAYMENT_TERMS_DRAWER_OPEN',
  SAVE_ERROR: 'common/drawers/accountDrawer/SAVE_ERROR',
  SAVE_REQUEST: 'common/drawers/accountDrawer/SAVE_REQUEST',
  SAVE_SUCCESS: 'common/drawers/accountDrawer/SAVE_SUCCESS',
};

export const createPaymentTerms = {
  error: notify(
    (error) => ({
      type: types.CREATE_PAYMENT_TERMS_ERROR,
      payload: error,
    }),
    'Failed to create payment terms',
  ),
  request: ({ label, period }) => ({
    type: types.CREATE_PAYMENT_TERMS_REQUEST,
    payload: { label, period },
  }),
  success: ({ paymentTerm }) => ({
    type: types.CREATE_PAYMENT_TERMS_SUCCESS,
    payload: { paymentTerm },
  }),
};

export const paymentTermsDrawer = {
  close: () => ({
    type: types.PAYMENT_TERMS_DRAWER_CLOSE,
  }),
  open: ({ cb }) => ({
    type: types.PAYMENT_TERMS_DRAWER_OPEN,
    payload: { cb },
  }),
};

export const save = {
  error: notify(
    (error) => ({
      type: types.SAVE_ERROR,
      payload: error,
    }),
    'Failed to save account',
  ),
  request: ({
    address1,
    address2,
    city,
    country,
    creditCardsEnabled,
    creditLine,
    erpCode,
    name,
    notes,
    paymentTermsId,
    phone,
    phoneExt,
    postalCode,
    purchaseOrders,
    salespersonId,
    state,
    taxExempt,
    taxRate,
    type,
    url,
    accountId,
    mode,
    onClose,
    onSaveCallback,
  }) => ({
    type: types.SAVE_REQUEST,
    payload: {
      address1,
      address2,
      city,
      country,
      creditCardsEnabled,
      creditLine,
      erpCode,
      name,
      notes,
      paymentTermsId,
      phone,
      phoneExt,
      postalCode,
      purchaseOrders,
      salespersonId,
      state,
      taxExempt,
      taxRate,
      type,
      url,
      accountId,
      mode,
      onClose,
      onSaveCallback,
    },
  }),
  success: ({ account }) => ({
    type: types.SAVE_SUCCESS,
    payload: { account },
  }),
};

export const setPaymentTerms = (paymentTerms) => ({
  type: types.GET_PAYMENT_TERMS,
  payload: paymentTerms,
});
